import type { ReactElement, ReactNode } from "react";

import { Box } from "@similarweb/ui-components/foundations";

import {
    StyledIconButtonWrapper,
    StyledTooltip,
    StyledTooltipContent,
    StyledUpgradeButton,
} from "../ColumnOptionView/styles";

type Props = {
    tooltipContent: ReactNode;
};

export const UpgradeColumnButton = ({ tooltipContent }: Props): ReactElement => {
    return (
        <StyledTooltip
            placement="right"
            content={<StyledTooltipContent>{tooltipContent}</StyledTooltipContent>}
        >
            <Box>
                <StyledIconButtonWrapper>
                    <StyledUpgradeButton
                        iconName="sparkles"
                        iconSize="24px"
                    />
                </StyledIconButtonWrapper>
            </Box>
        </StyledTooltip>
    );
};
